(function(){
    'use strict'

    angular
    .module('app.devengados')
    .controller('OtrosDevengados', OtrosDevengados);

    OtrosDevengados.$inject = ['$animationsSrv', 'DevengadosService', 'logger', '$location', 'UserInfoService'];

    function OtrosDevengados($animationsSrv, DevengadosService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.devengados = [];
        vm.title = 'OtrosDevengados';

        vm.goToEdit = function(devengado){
            
            var path = '/editar-otro-devengado/';

            if(devengado){
                $location.path(path + devengado.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = DevengadosService.getAllOtros();

            promise
            .then(function(devengados){
                vm.devengados = devengados;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las devengados.');
                        break;
                }
            });
        };

        vm.delete = function(devengado){
            var promise = DevengadosService.removeOtros(devengado);
            
            promise
            .then(function(response){
                vm.devengados = vm.devengados.filter(function(g) {
                    return g.id !== devengado.id;
                });
                logger.success('Devengado eliminada con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un error al eliminar la Devengado');
                        break;
                }
                
            });   
        };

    }
})();